import { Link, useSearchParams } from 'react-router-dom';
import { getBackendUrl } from '../api';

export default function Viewer() {
  const [params] = useSearchParams();
  const rel = params.get('rel') || '';
  if (!rel) return <div style={{padding:16}}>No image selected.</div>;
  return (
    <div style={{padding:0}}>
      <div style={{
        padding:12,
        borderBottom:'1px solid var(--color-border)',
        display:'flex',
        gap:12,
        alignItems:'center',
        background:'linear-gradient(135deg, rgba(255, 245, 247, 0.55), rgba(255, 255, 255, 0.35))',
        backdropFilter:'blur(8px) saturate(120%)'
      }}>
        <Link to={-1} style={{
          display:'inline-block',
          padding:'8px 12px',
          borderRadius:999,
          border:'1px solid var(--color-border)',
          textDecoration:'none',
          color:'var(--color-text)',
          background:'#ffffffcf'
        }}>← Back</Link>
        <a href={getBackendUrl(`/api/download?rel=${encodeURIComponent(rel)}`)} style={{
          display:'inline-block',
          padding:'8px 12px',
          borderRadius:999,
          border:'1px solid var(--color-primary-700)',
          textDecoration:'none',
          color:'#ffffff',
          background:'var(--color-primary)',
          boxShadow:'0 6px 18px rgba(22, 163, 74, 0.28)'
        }}>Download</a>
      </div>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center',minHeight:'calc(100vh - 60px)',background:'#111'}}>
        <img src={getBackendUrl(`/api/image?rel=${encodeURIComponent(rel)}`)} alt={rel} style={{maxWidth:'95vw',maxHeight:'85vh'}} />
      </div>
    </div>
  );
}

